
export default {
  Module: "domina",
  Version: "1",
  Agency: {
    environmentId: process.env.ENVIROMENT_ID
  },
  Settings: {
    None: "none",
    Undefined: "undefined",
    Empty: "",
  },
  Status: {
    enable: "Enabled",
    disabled: "Disabled",
    showed: "Showed",
    hided: "Hided",
    unlocked: "Unlocked",
    locked: "Locked",
    selected: "Selected",
    unselected: "Unselected",
    delete: "Deleted",
    shared: "Shared",
    unshared: "Unshared",
    terminated: "Terminated"
  },
  Type: {
    Employee: "employee",
    Candidate: "candidate",
    Employer: "employer",
    Contract: "contract",
    Recruit: "recruit",
    Dashboard: "dashboard",
    ContractExpire: "ContractExpire",
    DriverLicense: "DriverLicense",
    ResidentStreet: "ResidentStreet",
    DomicileStreet: "DomicileStreet",
    DistanceFromHome: "DistanceFromHome",
    IsEligibleForSearch: "IsEligibleForSearch"
  },
  CardType: {
    FC: "FC",
  },
  fieldsName: {
    uuid: "uuid",
    name: "name",
    surname: "surname",
    email: "email",
    mobile: "mobile",
    birthDate: "birthdate",
    birthplace: "birthplace",
    type: "type",
    forms: "forms",
    topId: "topId",
    statuses: "statuses",
    country: "country",
    created: "created",
    extras: "extras",
    citizenship: "extras.object.sections.fields.citizenship.value",
    sex: "sex",
    province: "extras.object.sections.fields.domicileProvince.value",
    // province: "addresses.province",
    domesticPartnership: "extras.object.sections.fields.hasDomesticPartnership.value",
    timePeriod: "extras.object.sections.fields.hasTimePeriod.value",
    hours: "extras.object.sections.fields.hours.value",
    workingHours: "extras.object.sections.fields.workingHours.value",
    partTime: "extras.object.sections.fields.partTime.value",
    uniCertification: "extras.object.sections.fields.obtainingUni11766Cert.value",
    professionalTrainingDiploma: "extras.object.sections.fields.requireTrainingDiploma.value",
    assistanceExperiencesNonSelfSufficientPersons: "extras.object.sections.fields.asstExpNonSelfSufficient.value",
    trainingCourses: "extras.object.sections.fields.attendedTrainingCourses.value",
    houseCleaningLevelA: "extras.object.sections.fields.houseCleaning.value",
    laundryLevelA: "extras.object.sections.fields.laundry.value",
    cookingAidLevelA: "extras.object.sections.fields.cookingAid.value",
    stablemanLevelA: "extras.object.sections.fields.stableman.value",
    assistantPetsLevelA: "extras.object.sections.fields.assistantPets.value",
    greenAreasLevelA: "extras.object.sections.fields.greenAreas.value",
    commonWorkerLevelA: "extras.object.sections.fields.commonWorker.value",
    companyOfficerLevelAS: "extras.object.sections.fields.companyOfficer.value",
    multiCollaboratorLevelB: "extras.object.sections.fields.multiCollaborator.value",
    guardianPrivateHouseLevelB: "extras.object.sections.fields.guardianPrivateHouse.value",
    ironingManagerLevelB: "extras.object.sections.fields.ironingManager.value",
    waiterLevelB: "extras.object.sections.fields.waiter.value",
    gardenerLevelB: "extras.object.sections.fields.gardener.value",
    qualifiedWorkerLevelB: "extras.object.sections.fields.qualifiedWorker.value",
    driverLevelB: "extras.object.sections.fields.driver.value",
    roomCleanerLevelB: "extras.object.sections.fields.roomCleaner.value",
    familyAsstSelfLevelBS: "extras.object.sections.fields.familyAsstSelf.value",
    familyAsstChildrenLevelBS: "extras.object.sections.fields.familyAsstChildren.value",
    cookLevelC: "extras.object.sections.fields.cook.value",
    familyAsstNonSelfNotTrainedLevelCS: "extras.object.sections.fields.familyAsstNonSelfNotTrained.value",
    adminFamilyAssetsLevelD: "extras.object.sections.fields.adminFamilyAssets.value",
    butlerLevelD: "extras.object.sections.fields.butler.value",
    housekeeperLevelD: "extras.object.sections.fields.housekeeper.value",
    chiefChefLevelD: "extras.object.sections.fields.chiefChef.value",
    headGardenerLevelD: "extras.object.sections.fields.headGardener.value",
    instructorLevelD: "extras.object.sections.fields.instructor.value",
    familyAsstTrainedLevelDS: "extras.object.sections.fields.familyAsstTrained.value",
    houseManagerLevelDS: "extras.object.sections.fields.houseManager.value",
    familyAsstEducatorLevelDS: "extras.object.sections.fields.familyAsstEducator.value",
    idNumber: "extras.object.sections.fields.idNumber.value",
    from: "from",
    to: "to",
    agencyId: "agencyId",
    idCards: "idcards",
    contractId: "contractId",
    companyId: "companyId",
  },
  formPrint: {
    basePath: "/var/opt/pdf",
    baseFileName: "domina",
    templateCandidatePath: "/var/opt/pdf/templates/template_domina_candidate_mod3_v1.pdf",
    templateEmployeePath: "/var/opt/pdf/templates/template_domina_candidate_mod3_v1.pdf",
    templateEmployerPath: "/var/opt/pdf/templates/template_domina_employer_mod2_v1.pdf",
    templateContractPath: "/var/opt/pdf/templates/template_domina_contract_mod1_v1.pdf",
    candidate: "templates/template_domina_candidate_mod3_v1.pdf",
    employee: "templates/template_domina_candidate_mod3_v1.pdf",
    employer: "templates/template_domina_employer_mod2_v1.pdf",
    contract: "templates/template_domina_contract_mod1_v1.pdf",
    agencyIdDomina: "H501S011662",
  },
  date: {
    dateFormatUI: "DD/MM/YYYY",
    dateFormatDB: "YYYY/MM/DD",
  },
  fieldType: {
    boolean: "boolean",
    string: "string",
    object: "object",
  },
  selectionType: {
    single: "single",
    multiple: "multiple",
    none: "none"
  },
  notify: {
    success: "success",
    error: "error",
    topRight: "top-right"
  },
  options: {
    view: "view",
    edit: "edit",
    print: "print",
    share: "share",
    shared: "shared",
    delete: "delete",
    terminate: "terminate",
    askInformation: "askInfo",
  },
  menuList: {
    candidate: 'candidate',
    all: 'all',
    recruit: 'recruit',
    mainList: 'candidate_employee_employer_contract',
    employer: 'employer',
    contract: "contract"
  },
  orderBy: {
    desc: "desc"
  },
  models: {
    workExperience: 'workExperience',
    workTraining: 'houseWorkTraining'
  }
}
